var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"app-container d-flex align-center justify-center",attrs:{"fluid":""}},[_vm._t("appContainerContent")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }